import { z } from 'zod';
/**
 * Branded type for Node IDs to ensure type safety
 */
export const NodeIdSchema = z.string().min(1).brand();
/**
 * Home Assistant entity ID format: domain.entity_name
 */
export const EntityIdSchema = z
    .string()
    .regex(/^[a-z_]+\.[a-z0-9_]+$/, 'Entity ID must be in format: domain.entity_name (e.g., light.living_room)');
/**
 * Position in the React Flow canvas
 */
export const PositionSchema = z.object({
    x: z.number(),
    y: z.number(),
});
/**
 * Handle configuration for node connections
 */
export const HandleSchema = z.object({
    id: z.string(),
    type: z.enum(['source', 'target']),
    position: z.enum(['top', 'bottom', 'left', 'right']),
});
/**
 * Common metadata for automation/script configuration
 */
export const AutomationModeSchema = z.enum(['single', 'restart', 'queued', 'parallel']);
export const MaxExceededSchema = z.enum(['silent', 'warning', 'critical']);
//# sourceMappingURL=base.js.map